<template>
  <q-row
    class="container"
  >
    <div class="contact-content">
      <q-content-loader :content="content" />
    </div>
  </q-row>
</template>

<script>
  import contentLoader from "../../../components/contentLoader";

  export default {
    name: "QContact",

    components: {
      'q-content-loader': contentLoader
    },

    data() {
      return {
        content:{},
      }
    },

    computed: {
    },

    methods: {
      initialize() {
        this.$delegate('edms', 'getContentAsPage', {
          key: 'contact-page'
        }).then((response) => {
          this.content = response.result;
        }).catch((err) => {
          this.$notify({
            title: 'Exception in page',
            message: err,
            type: 'error'
          });
        });
      },
    },


    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    },
    beforeRouteUpdate(to, from, next) {
      this.initialize();
      next();
    }
  }
</script>

<style scoped>

</style>